import moment from "moment";
import ApiService from "../ApiService";

const user = JSON.parse(localStorage.getItem("user"));

export default class PromotionService {
  static getDataMall = async (params) => {
    let property_id = "";

    //jika role admin csn dan admin izy , get semua mall
    if (user.role.id > 2 && user.role.id !== 25) {
      property_id = `&property_id=${user.operational.id}`;
    } else {
      property_id = `&property_id=${params.property_id}`;
    }
    let num,
      cursor,
      keyword,
      type,
      level,
      approved,
      deleted,
      is_landing,
      current_date,
      is_active;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }
    if (
      (params.is_active && params.is_active !== "") ||
      params.is_active === 0
    ) {
      is_active = `&is_active=${params.is_active}`;
    }
    if (params.current_date && params.current_date !== "") {
      current_date = `&current_date=${params.current_date}`;
    }
    if (params.is_landing && params.is_landing !== "") {
      is_landing = `&is_landing=${params.is_landing}`;
    }
    // if (params.property_id && params.type !== "") {
    //   property_id = `&type=${params.property_id}`;
    // }

    if (params.deleted && params.deleted !== "") {
      deleted = `&removed=${params.deleted}`;
    } else {
      deleted = `&removed=false`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/promotion?${num || ""}${property_id}${type || ""}${cursor || ""}${
        keyword || ""
      }${deleted || ""}${is_landing || ""}${current_date || ""}${
        is_active || ""
      }`
    );
  };

  static storeDataMall = async (params) => {
    const instance = await ApiService();

    // const params = {
    // 	property: { id: user.operational.id },
    // 	title: value.title,
    // 	description: value.description,
    // 	image_urls: value.image_urls,
    // 	image_banner_url: value.image_urls[0],
    // 	start_time: moment(value.startTime).utc().format(),
    // 	end_time: moment(value.endTime).utc().format(),
    // 	type: "property",
    // 	link_url: value.link_url,
    // 	approved: true,
    // };

    return instance.post(`/promotion`, params);
  };

  static putDataMall = async (id, value) => {
    const instance = await ApiService();
    const params = {
      property: { id: user.operational.id },
      title: value.title,
      description: value.description,
      image_urls: value.image_urls,
      image_banner_url: value.image_urls[0],
      start_time: moment(value.start_time).utc().format(),
      end_time: moment(value.end_time).utc().format(),
      type: "property",
      link_url: value.link_url,
      approved: value.approved,
      is_landing: value.is_landing,
      with_product: value.with_product,
      product: value.product,
    };
    return instance.put(`/promotion/${id}`, params);
  };

  static deleteMall = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/promotion/${id}`);
  };

  static patchMall = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/promotion/${id}`, params);
  };

  // Promotion Tenant
  static getDataTenant = async (params) => {
    // let property_id = `&property_id=${user.operational.id}`;
    let property_id = "";

    //jika role admin csn dan admin izy , get semua mall
    if (user.role.id > 2) {
      property_id = `&property_id=${user.operational.id}`;
    } else {
      property_id = `&property_id=${params.property_id}`;
    }
    let tenant_id =
      user.type === "tenant"
        ? `&tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `&tenant_id=${params.tenant_id}`
        : "";

    let num, cursor, keyword, type, approved, deleted, level;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (params.approved && params.approved !== "") {
      approved = `&approved=${params.approved}`;
    } else {
      approved = `&approved=false`;
    }

    if (params.deleted && params.deleted !== "") {
      deleted = `&removed=${params.deleted}`;
    } else {
      deleted = `&removed=false`;
    }

    const instance = await ApiService();
    return instance.get(
      `/promotion?${num || ""}${property_id}${tenant_id}${type || ""}${
        cursor || ""
      }${keyword || ""}${deleted || ""}${approved || ""}`
    );
  };
  static getDataTenantHighlight = async (params) => {
    // let property_id = `&property_id=${user.operational.id}`;
    let property_id = "";

    //jika role admin csn dan admin izy , get semua mall
    if (user.role.id > 2) {
      property_id = `&property_id=${user.operational.id}`;
    } else {
      property_id = `&property_id=${params.property_id}`;
    }
    let tenant_id =
      params.tenant_id || params.tenant_id === 0
        ? `&tenant_id=${params.tenant_id}`
        : "";
    console.log(params);
    console.log("*****");
    let num, cursor, keyword, type, approved, deleted, level, is_landing;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }
    if (params.is_landing && params.is_landing !== "") {
      is_landing = `$is_landing=${params.is_landing}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (params.approved && params.approved !== "") {
      approved = `&approved=${params.approved}`;
    } else {
      approved = `&approved=false`;
    }

    if (params.deleted && params.deleted !== "") {
      deleted = `&removed=${params.deleted}`;
    } else {
      deleted = `&removed=false`;
    }

    const instance = await ApiService();
    return instance.get(
      `/promotion?${num || ""}${property_id}${tenant_id}${type || ""}${
        cursor || ""
      }${keyword || ""}${deleted || ""}${approved || ""}`
    );
  };

  static storeDataTenant = async (value) => {
    let tenant_id = user.tenant.id === 0 ? value.tenant : user.tenant.id;
    let approve_tenant = user.tenant.id === 0 ? true : false;
    const instance = await ApiService();
    const params = {
      property: { id: user.operational.id },
      tenant: {
        id: tenant_id,
      },
      title: value.title,
      description: value.description,
      image_urls: value.image_urls,
      image_banner_url: value.image_urls[0],
      start_time: moment(value.startTime).utc().format(),
      end_time: moment(value.endTime).utc().format(),
      type: "tenant",
      link_url: value.link_url,
      approved: approve_tenant,
    };

    return instance.post(`/promotion`, params);
  };

  static putDataTenant = async (id, value) => {
    let tenant_id = user.tenant.id === 0 ? value.tenant : user.tenant.id;
    let approve_tenant = user.tenant.id === 0 ? true : false;

    const instance = await ApiService();
    const params = {
      tenant: {
        id: tenant_id,
      },
      title: value.title,
      sub_title: value.subTitle,
      description: value.description,
      image_urls: value.image_urls,
      image_banner_url: value.image_urls[0],
      start_time: moment(value.start_time).utc().format(),
      end_time: moment(value.end_time).utc().format(),
      type: "tenant",
      link_url: value.link_url,
      approved: approve_tenant,
      product: value.product,
      with_product: value.with_product,
      is_landing: value.is_landing,
    };
    console.log(params);
    console.log("?????");
    console.log(value);
    return instance.put(`/promotion/${id}`, params);
  };

  static deletedTenant = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/promotion/${id}`);
  };

  static approvedTenant = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/promotion/${id}`, params);
  };

  static patchTenant = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/promotion/${id}`, params);
  };
}
